import { ID_PATTERN_TOKENS } from 'utils/constants'

const TAG_TYPES = {
    STUDY_ID: ID_PATTERN_TOKENS.STUDY_ID,
    SITE_ID: ID_PATTERN_TOKENS.SITE_ID,
    LETTERS: ID_PATTERN_TOKENS.LETTERS_UPPERCASE, // alias for convenience
    INCR: ID_PATTERN_TOKENS.INCR,
    LETTERS_UPPERCASE: ID_PATTERN_TOKENS.LETTERS_UPPERCASE,
    LETTERS_LOWERCASE: ID_PATTERN_TOKENS.LETTERS_LOWERCASE,
    LETTERS_MIXED: ID_PATTERN_TOKENS.LETTERS_MIXED,
    DIGITS: ID_PATTERN_TOKENS.DIGITS,
    // ALNUM tokens from backend/ID builder – map to existing alphanumeric types
    ALNUM: ID_PATTERN_TOKENS.ALPHANUMERIC_UPPERCASE,
    ALNUM_LOWER: ID_PATTERN_TOKENS.ALPHANUMERIC_LOWERCASE,
    ALNUM_MIXED: ID_PATTERN_TOKENS.ALPHANUMERIC_MIXED,
    ALPHANUMERIC_UPPERCASE: ID_PATTERN_TOKENS.ALPHANUMERIC_UPPERCASE,
    ALPHANUMERIC_LOWERCASE: ID_PATTERN_TOKENS.ALPHANUMERIC_LOWERCASE,
    ALPHANUMERIC_MIXED: ID_PATTERN_TOKENS.ALPHANUMERIC_MIXED,
    HEX_UPPERCASE: ID_PATTERN_TOKENS.HEX_UPPERCASE,
    HEX_LOWERCASE: ID_PATTERN_TOKENS.HEX_LOWERCASE,
    LITERAL: ID_PATTERN_TOKENS.LITERAL,
};

const getCount = (val) => {
    const n = parseInt(val, 10)
    return Number.isFinite(n) && n > 0 ? n : 4
}

/* 
   ⚡ NEW PLACEHOLDER SAMPLE VALUES
   - DIGITS → 1234
   - UPPERCASE → ABCD
   - LOWERCASE → abcd
   - MIXED → AbAb
   - INCR → 001 / 0001
*/

export const generateSampleFromFormat = (format, studyId, siteId) => {
    const previewMap = {
        [TAG_TYPES.LETTERS_UPPERCASE]: (t) => {
            const c = getCount(t.value)
            return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.substring(0, c)
        },
        [TAG_TYPES.LETTERS_LOWERCASE]: (t) => {
            const c = getCount(t.value)
            return 'abcdefghijklmnopqrstuvwxyz'.substring(0, c)
        },
        [TAG_TYPES.LETTERS_MIXED]: (t) => {
            const c = getCount(t.value)
            return 'Ab'.repeat(Math.ceil(c / 2)).substring(0, c)
        },
        [TAG_TYPES.DIGITS]: (t) => {
            const c = getCount(t.value)
            return '1234567890'.substring(0, c)
        },
        [TAG_TYPES.ALPHANUMERIC_UPPERCASE]: (t) => {
            const c = getCount(t.value)
            return 'A1B2C3'.repeat(Math.ceil(c / 4)).substring(0, c)
        },
        [TAG_TYPES.ALPHANUMERIC_LOWERCASE]: (t) => {
            const c = getCount(t.value)
            return 'a1b2c3'.repeat(Math.ceil(c / 4)).substring(0, c)
        },
        [TAG_TYPES.ALPHANUMERIC_MIXED]: (t) => {
            const c = getCount(t.value)
            return 'A1b2C3'.repeat(Math.ceil(c / 6)).substring(0, c)
        },
        [TAG_TYPES.HEX_UPPERCASE]: (t) => {
            const c = getCount(t.value)
            return 'ABCDEF1234'.substring(0, c)
        },
        [TAG_TYPES.HEX_LOWERCASE]: (t) => {
            const c = getCount(t.value)
            return 'abcdef1234'.substring(0, c)
        },
        [TAG_TYPES.INCR]: (t) => {
            // For INCR, t.value is the starting value (e.g., "01", "47", "001")
            // Return it as-is to show the actual starting value
            if (t.value) {
                return t.value;
            }
            // Fallback: if no value provided, use default format
            const c = getCount(t.value)
            return String('0'.repeat(c - 1) + '1')  // 001, 0001, etc.
        },
        [TAG_TYPES.STUDY_ID]: () => studyId || 'STUDYID',
        [TAG_TYPES.SITE_ID]: () => siteId || 'SITEID',
        [TAG_TYPES.LITERAL]: (t) => t.value,
    }

    // Updated regex to handle INCR with any starting value (e.g., {INCR:47}, {INCR:01})
    // Pattern: {WORD} or {WORD:VALUE} where VALUE can be any string (not just digits)
    const tokenRegex = /\{([^}]+)\}|([^{]+)/g

    const parseFormatString = (format) => {
        if (!format) return []

        const tags = []
        let match

        while ((match = tokenRegex.exec(format)) !== null) {
            const [fullMatch, tokenContent, literal] = match

            if (tokenContent) {
                // Token content like "INCR:47" or "STUDY_ID"
                const parts = tokenContent.split(':')
                const type = parts[0].toUpperCase()
                const value = parts.length > 1 ? parts.slice(1).join(':') : null // Join in case value contains colons

                if (TAG_TYPES[type]) {
                    tags.push({ type: TAG_TYPES[type], value })
                } else {
                    tags.push({ type: TAG_TYPES.LITERAL, value: `{${tokenContent}}` })
                }
            } else if (literal) {
                tags.push({ type: TAG_TYPES.LITERAL, value: literal })
            }
        }

        return tags
    }
    const tags = parseFormatString(format)
    if (tags.length === 0) return ''

    return tags
        .map((tag) => (previewMap[tag.type] ? previewMap[tag.type](tag) : ''))
        .join('')
}
